import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import ImageWithBasePath from "../imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu } from "../../data/redux/sidebarSlice";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import usePreviousRoute from "./usePreviousRoute";
import { SidebarDataTest } from "../../data/json/sidebarMenu";
import { fetchCompanyDetailsById } from "../../data/redux/company/companyDetailsActions";
import { AppDispatch } from "../../data/redux/store";
import { getUserMenuPermissions } from "../../data/redux/user/rolePermission/rolePermissionAction";
import { fetchAllConfigSettings } from "../../data/redux/user/configurationSetting/configurationSettingsActions";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { Drawer, message, Spin } from "antd";
import { encryptData } from "../../utils/encryptUtils";
import { useAISidebarSearch } from "../../AiActions/customHooks/useAISidebarSearch";
import AISearchDrawer from "../../AiActions/AISearchDrawer";
import AIActionListener from "../../AiActions/AIActionListener";
const Sidebar = () => {
  const Location = useLocation();
  const { selectedCompany = {} } = useSelector((state: any) => state.companyDetails || {});
  const { userMenuPermissions } = useSelector((state: any) => state.rolePermission);
  const { companyDetails = [] } = useSelector((state: any) => state.companyDetails || []);
  const [subOpen, setSubopen] = useState<any>("Dashboard");
  const [subsidebar, setSubsidebar] = useState("");
  const searchQuery = useSelector((state: any) => state.sidebarSearch.query);
  const { suggestions, updateSuggestionsList, searchMenus } = useAISidebarSearch();
  const [aiSearchOpen, setAiSearchOpen] = useState(false);
  const [aiQuery, setAiQuery] = useState("");
  const [allMenuFlatten, setAllMenuFlatten] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const handleAISearch = () => {
    const result = searchMenus(aiQuery);

    if (result) {
      navigate(result.link);
      setAiSearchOpen(false);
      return;
    }

    if (suggestions.length > 0) {
      navigate(suggestions[0].link);
      setAiSearchOpen(false);
      return;
    }

    message.error("No matching menu found");
  };


  useEffect(() => {
    if (!selectedCompany || !selectedCompany.company_detail_id) {
      const activeCompany = companyDetails.find(
        (company: any) => company.status === "active"
      );

      if (activeCompany && activeCompany.company_detail_id) {
        dispatch(fetchCompanyDetailsById(activeCompany.company_detail_id));
      }
    }
  }, [dispatch]);
  // 2. Fetch user menu permissions
  useEffect(() => {
    if (!userMenuPermissions.length) {
      dispatch(getUserMenuPermissions());
    }
  }, [dispatch, userMenuPermissions.length]);

  // 3. Fetch config settings
  useEffect(() => {
    dispatch(fetchAllConfigSettings());
  }, [dispatch]);

  const getPermissions = (label: string): string[] => {
    console.log("Fetching permissions for label:", label);
    return userMenuPermissions.menuPermissions[label] || [];
  };

  const hasPermission = (label: string): boolean => {
    return Object.prototype.hasOwnProperty.call(userMenuPermissions.menuPermissions, label);
  };

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };
  const location = useLocation();

  const previousLocation = usePreviousRoute();

  useEffect(() => {
    const layoutPages = [
      "/layout-dark",
      "/layout-rtl",
      "/layout-mini",
      "/layout-box",
      "/layout-default",
    ];

    const isCurrentLayoutPage = layoutPages.some((path) =>
      location.pathname.includes(path)
    );
    const isPreviousLayoutPage =
      previousLocation &&
      layoutPages.some((path) => previousLocation.pathname.includes(path));


  }, [location, previousLocation, dispatch]);

  useEffect(() => {
    const currentMenu = localStorage.getItem("menuOpened") || 'Dashboard'
    setSubopen(currentMenu);
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };
  const config = useAppConfig();
  if (!config) {
    return (
      <div style={{
        height: '100vh',
        width: '250px', // typical sidebar width
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5', // match sidebar background
      }}>
        <Spin size="large" tip="Loading Sidebar..." />
      </div>
    );
  }

  const filterMenuItems: any = (menuArray: any[]) => {
    return menuArray
      .map((item) => {
        let label = item.label;

        // Rename based on country condition
        if (config.country === 'Ghana') {
          if (label === 'TDS') {
            label = 'PAYEE';
          }
        }

        // Rename PF-related labels (both parent and child levels)
        if (!config.pf_reporting_enabled) {
          if (label === 'Provident Fund') {
            label = 'General Provident Fund';
          }
        }

        // Recursively process submenu items
        let submenuItems = [];
        if (item.submenuItems && item.submenuItems.length > 0) {
          submenuItems = filterMenuItems(item.submenuItems);
        }

        // Now rename submenus like "EPF Dashboard" even if deeply nested
        if (!config.pf_reporting_enabled) {
          submenuItems = submenuItems.map((subItem: any) => {
            if (subItem.label === 'EPF Dashboard') {
              return { ...subItem, label: 'GPF Dashboard' };
            }
            return subItem;
          });
        }

        // Keep the parent if it has submenuItems or user has permission
        if ((submenuItems && submenuItems.length > 0) || hasPermission(label)) {
          return {
            ...item,
            label,
            submenuItems,
          };
        }

        return null;
      })
      .filter(Boolean); // remove null entries
  };


  // This new recursive function filters menu items based on the search query.
  // It checks the item's label and recursively checks its children.
  const recursiveSearchFilter = (items: any[], query: string) => {
    const lowerCaseQuery = query.toLowerCase();

    // If there is no search query, return all items.
    if (!lowerCaseQuery) {
      return items;
    }

    return items.reduce((acc, item) => {
      // Check if the current item's label matches the search query.
      const selfMatch = item.label && item.label.toLowerCase().includes(lowerCaseQuery);

      let filteredSubItems: any[] = [];
      // If the item has a submenu, filter it recursively.
      if (item.submenuItems && item.submenuItems.length > 0) {
        filteredSubItems = recursiveSearchFilter(item.submenuItems, query);
      }

      // The item should be included in the results if it matches the query
      // or if any of its children match the query.
      if (selfMatch || filteredSubItems.length > 0) {
        acc.push({
          ...item,
          // If the parent item itself matches, we want to show all its children.
          // Otherwise, we show only the children that matched the search.
          submenuItems: selfMatch ? (item.submenuItems || []) : filteredSubItems,
        });
      }

      return acc;
    }, []);
  };

  // First, filter the sidebar data based on permissions and configuration.
  const permissionFilteredMenus = filterMenuItems(SidebarDataTest);

  const filteredSidebar = permissionFilteredMenus.map((mainMenu: any) => {
    const searchFilteredSubmenus = mainMenu.submenuItems ? recursiveSearchFilter(mainMenu.submenuItems, searchQuery) : [];

    return {
      ...mainMenu,
      submenuItems: searchFilteredSubmenus,
    };
  }).filter((mainMenu: any) => mainMenu.submenuItems && mainMenu.submenuItems.length > 0);

  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="sidebar-logo">
          <Link to="routes.index" className="logo logo-normal">
            <img src={selectedCompany?.plugin_logo} alt="Logo" style={{
              maxWidth: '220px',
              maxHeight: '80px',
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
            }} />
          </Link>
          <Link to="routes.index" className="logo-small">
            <img src={selectedCompany?.plugin_logo} alt="Logo" style={{
              maxWidth: '220px',
              maxHeight: '80px',
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
            }} />
          </Link>
          <Link to={all_routes.adminDashboard} className="dark-logo">
            <img src={selectedCompany?.plugin_logo} alt="Logo" style={{
              maxWidth: '220px',
              maxHeight: '80px',
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
            }} />
            {/* <ImageWithBasePath src="assets/img/hrmlogo24.svg" alt="Logo" style={{ width: '220px', height: 'auto', marginLeft: '' }} /> */}
          </Link>
        </div>
        <div className="modern-profile p-3 pb-0">
          <div className="text-center rounded bg-light p-3 mb-4 user-profile">
            <div className="avatar avatar-lg online mb-3">
              <ImageWithBasePath
                src="assets/img/profiles/avatar-02.jpg"
                alt="Img"
                className="img-fluid rounded-circle"
              />
            </div>
            <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
            <p className="fs-10">System Admin</p>
          </div>
          <div className="sidebar-nav mb-3">
            <ul
              className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
              role="tablist"
            >
              <li className="nav-item">
                <Link className="nav-link active border-0" to="#">Menu</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link border-0" to="#">Chats</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link border-0" to="#">Inbox</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="sidebar-header p-3 pb-0 pt-5">
          <div
            className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center"
          >
            <div className="avatar avatar-md onlin">
              <ImageWithBasePath
                src="assets/img/profiles/avatar-02.jpg"
                alt="Img"
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="text-start sidebar-profile-info ms-2">
              <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
              <p className="fs-10">System Admin</p>
            </div>
          </div>
          <div className="input-group input-group-flat d-inline-flex mb-4">
            <span className="input-icon-addon">
              <i className="ti ti-search"></i>
            </span>
            <input type="text" className="form-control" placeholder="Search in hrmtree" />
            <span className="input-group-text">
              <kbd>CTRL + / </kbd>
            </span>
          </div>
          <div
            className="d-flex align-items-center justify-content-between menu-item mb-3"
          >
            <div className="me-3">
              <Link to="#" className="btn btn-menubar position-relative">
                <i className="ti ti-shopping-bag"></i>
                <span className="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge"
                >5</span>
              </Link>
            </div>
            <div className="me-3">
              <Link to="#" className="btn btn-menubar">
                <i className="ti ti-layout-grid-remove"></i>
              </Link>
            </div>
            <div className="me-3">
              <Link to="#" className="btn btn-menubar position-relative">
                <i className="ti ti-brand-hipchat"></i>
                <span
                  className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
                >5</span>
              </Link>
            </div>
            <div className="me-3 notification-item">
              <Link to="#" className="btn btn-menubar position-relative me-1">
                <i className="ti ti-bell"></i>
                <span className="notification-status-dot"></span>
              </Link>
            </div>
            <div className="me-0">
              <Link to="#" className="btn btn-menubar">
                <i className="ti ti-message"></i>
              </Link>
            </div>
          </div>
        </div>
        <Scrollbars className="mt-4">
          <div className="sidebar-inner slimscroll pb-5">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {/* SidebarDataTest */}
                {/* filteredSidebar */}
                {filteredSidebar?.map((mainLabel: any, index: any) => (
                  <React.Fragment key={`main-${index}`}>
                    <li className="menu-title">
                      <span style={{ fontSize: "15px", fontWeight: "500" }}>
                        {mainLabel?.tittle}
                      </span>
                    </li>
                    <li>
                      <ul>
                        {mainLabel?.submenuItems?.map((title: any, i: any) => {
                          let link_array: any = [];
                          if ("submenuItems" in title) {
                            title.submenuItems?.forEach((link: any) => {
                              link_array.push(link?.link);
                              if (link?.submenu && "submenuItems" in link) {
                                link.submenuItems?.forEach((item: any) => {
                                  link_array.push(item?.link);
                                });
                              }
                            });
                          }
                          title.links = link_array;

                          return (
                            <li className="submenu" key={`title-${i}`}>
                              <Link
                                to={title?.submenu ? "#" : title?.link}
                                onClick={() => {
                                  const permissions = getPermissions(title.label);
                                  localStorage.setItem('currentPermissions', encryptData(permissions));
                                  handleClick(
                                    title?.label,
                                    title?.themeSetting,
                                    getLayoutClass(title?.label)
                                  )
                                }
                                }
                                className={`${subOpen === title?.label ? "subdrop" : ""
                                  } ${title?.links?.includes(Location.pathname) ? "active" : ""
                                  } ${title?.submenuItems
                                    ?.map((link: any) => link?.link)
                                    .includes(Location.pathname) ||
                                    title?.link === Location.pathname
                                    ? "active"
                                    : ""
                                  }`}
                              >
                                <i className={`ti ti-${title.icon}`} style={{ fontSize: "22px" }}></i>
                                <span>{title?.label}</span>
                                {title?.dot && (
                                  <span className="badge badge-danger fs-10 fw-medium text-white p-1">
                                    Hot
                                  </span>
                                )}
                                <span className={title?.submenu ? "menu-arrow" : ""} />
                              </Link>
                              {title?.submenu !== false && subOpen === title?.label && (
                                <ul
                                  style={{
                                    display: subOpen === title?.label ? "block" : "none",
                                  }}
                                >
                                  {title?.submenuItems?.map((item: any, j: any) => (
                                    <li
                                      className={
                                        item?.submenuItems ? "submenu submenu-two" : ""
                                      }
                                      key={`item-${j}`}
                                    >
                                      <Link
                                        to={item?.submenu ? "#" : item?.link}
                                        className={`${item?.submenuItems
                                          ?.map((link: any) => link?.link)
                                          .includes(Location.pathname) ||
                                          item?.link === Location.pathname
                                          ? "active"
                                          : ""
                                          } ${subsidebar === item?.label ? "subdrop" : ""
                                          }`}
                                        onClick={() => {
                                          const permissions = getPermissions(item.label);
                                          localStorage.setItem('currentPermissions', encryptData(permissions));
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={item?.submenu ? "menu-arrow" : ""}
                                        />
                                      </Link>
                                      {item?.submenuItems ? (
                                        <ul
                                          style={{
                                            display:
                                              subsidebar === item?.label ? "block" : "none",
                                          }}
                                        >
                                          {item?.submenuItems?.map((items: any, k: any) => (
                                            <li key={`submenu-item-${k}`}>
                                              <Link
                                                to={items?.submenu ? "#" : items?.link}
                                                onClick={() => {
                                                  const permissions = getPermissions(items.label);
                                                  localStorage.setItem('currentPermissions', encryptData(permissions));
                                                }}
                                                className={`${subsidebar === items?.label
                                                  ? "submenu-two subdrop"
                                                  : "submenu-two"
                                                  } ${items?.submenuItems
                                                    ?.map((link: any) => link.link)
                                                    .includes(Location.pathname) ||
                                                    items?.link === Location.pathname
                                                    ? "active"
                                                    : ""
                                                  }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      ) : null}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  </React.Fragment>
                ))}

              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>

      {/* AI Search Floating Button */}
      <AISearchDrawer />
      <AIActionListener />
    </>
  );
};

export default Sidebar;
